import connectionProxy from '../connectionProxy'

export const absentStudent = (studentId) => {
  return connectionProxy.patch(`exit_requests/toggle_presence`, { 'student_id': studentId })
}

export const authorize = ({ id, studentIds }) => {
  return connectionProxy.patch('exit_requests/authorize',
    { 'administrator_id': id, 'student_ids': studentIds })
}
